import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-midnight">
      <Header />
      <main className="flex-1 pt-20">{children}</main>
      <Footer />
    </div>
  );
}
